// extracted by mini-css-extract-plugin
export default {"image_div":"image_image_div__cQtR6","qns_image":"image_qns_image__I0zAa"};